module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1108.9b14226f.png";